var o = /* @__PURE__ */ ((r) => (r[r.EmailVerify = 0] = "EmailVerify", r[r.ForgotPassword = 1] = "ForgotPassword", r[r.SetUpEmailAndPassword = 2] = "SetUpEmailAndPassword", r[r.AccountRegister = 3] = "AccountRegister", r))(o || {});
export {
  o as OTPType
};
//# sourceMappingURL=email.js.map
